<div class="w-100 bg-lavendar mt-80">
  <app-header></app-header>
</div>
<div class="bg-color p-3">
  <app-filter></app-filter>
  <div class="px-0 py-3">
    <app-bread-crumb></app-bread-crumb>
  </div>
  <div class="container-fluid pr-0 pl-0">
    <div class="row">
      <div class="col-sm-2">
        <div class="single-left-pane">
          <app-side-menu></app-side-menu>
        </div>
      </div>
      <div [ngClass]="{ 
          'col-sm-7': !isRightPaneCollapsed, 
          'col-sm-10': isRightPaneCollapsed 
        }"
        style="position: relative;"
      >
        <div class="single-center-pane">
          <div
            class="d-flex align-items-center go-back-btn"
            role="button"
            (click)="goBack()"
          >
            <mat-icon matTooltip="Go back" matTooltipPosition="above"
              >keyboard_backspace</mat-icon
            >
          </div>
          <div class="row">
            <div class="d-flex align-items-center mb-2">
              <h5>Library</h5>
              <div class="ml-auto">
                <button
                  mat-flat-button
                  mat-button
                  color="primary"
                  class="bg-primary text-white mr-2"
                  (click)="navigateToIncidentTracker()"
                >
                  Audits
                </button>
              </div>
            </div>
            <div
              *ngIf="!readMode"
              class="mt-2 d-flex align-items-center justify-content-center"
            >
              <button
                mat-flat-button
                color="primary"
                class="mr-1"
                style="width: 100%"
                (click)="templateDownload()"
              >
                <mat-icon>cloud_download</mat-icon> &nbsp;
                <span>Download Template</span>
              </button>
              <input
                (change)="this.onFilechange($event)"
                class="form-control"
                type="file"
                #formFile
                hidden
              />
              <button
                mat-flat-button
                color="primary"
                class="mr-1"
                style="width: 100%"
                (click)="formFile.click()"
              >
                <mat-icon>cloud_upload</mat-icon> &nbsp;
                <span>Upload Template</span>
              </button>
            </div>
          </div>
          <app-loading *ngIf="!dataLoaded"></app-loading>
          <app-audits-library
            dataLoaded="{{ true }}"
            [filteredTemplate]="filteredTemplate"
            [unCategorizedTemplates]="unCategorizedTemplates"
          >
          </app-audits-library>
        </div>
        <button
          mat-icon-button
          (click)="toggleRightPane()"
          [matTooltip]="isRightPaneCollapsed ? 'Show Insights' : 'Hide Insights'"
          style="
            position: absolute;
            right: -2px;
            top: 50%;
            transform: translateY(-50%);
            z-index: 10;
            background: white;
            border: 1px solid #ddd;
            border-radius: 50%;
            width: 24px;
            height: 24px;
            line-height: 24px;
            box-shadow: 0 1px 3px rgba(0,0,0,0.2);
          "
        >
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; line-height: 16px;">
            {{ isRightPaneCollapsed ? 'chevron_left' : 'chevron_right' }}
          </mat-icon>
        </button>
      </div>
      <div [ngClass]="isRightPaneCollapsed ? 'col-sm-0' : 'col-sm-3'"
        style="transition: all 0.3s ease;"
      >
        <div class="single-right-pane" *ngIf="!isRightPaneCollapsed">
          <app-gnews></app-gnews>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
